import type { WidgetDefinition } from "@nexus/widget-sdk";
import widgetModule, { settings } from ".";

export const definition: WidgetDefinition = {
  id: "metric-kpi",
  module: widgetModule,
  catalog: {
    description:
      "Any metric of any metrics source, with its comparison trend. Prefer a domain indicator when there is one.",
    domain: "general",
    visual: "KPI",
    purposes: ["live", "reporting"],
    audiences: ["analyst", "client"],
  },
  layout: { kind: "content", skeleton: "kpi" },
  settings,
  defaultLayoutClassName: "col-span-12 xl:col-span-3",
};
